var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMappinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.445 17.18C11.6238 15.2625 15.5 11.345 15.5 7.75C15.5 5.76088 14.7098 3.85322 13.3033 2.4467C11.8968 1.04018 9.98912 0.25 8 0.25C6.01088 0.25 4.10322 1.04018 2.6967 2.4467C1.29018 3.85322 0.5 5.76088 0.5 7.75C0.5 11.345 4.375 15.2625 6.555 17.18C6.95264 17.5349 7.467 17.7311 8 17.7311C8.533 17.7311 9.04736 17.5349 9.445 17.18ZM5.5 7.75C5.5 7.08696 5.76339 6.45108 6.23223 5.98223C6.70107 5.51339 7.33696 5.25 8 5.25C8.66304 5.25 9.29893 5.51339 9.76777 5.98223C10.2366 6.45108 10.5 7.08696 10.5 7.75C10.5 8.41304 10.2366 9.04893 9.76777 9.51777C9.29893 9.98661 8.66304 10.25 8 10.25C7.33696 10.25 6.70107 9.98661 6.23223 9.51777C5.76339 9.04893 5.5 8.41304 5.5 7.75Z",
    fill: "#1C3D5D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMappinIcon);
export default __webpack_public_path__ + "static/media/mappin-icon.625181bdc89c9362c9b364ab3aa4314f.svg";
export { ForwardRef as ReactComponent };